<template lang="html">
  <transition name="modal-fade">
    <div class="modal-background">

    	<div id="user-wish-support-box" class="white-box" role="dialog">
        <div class="sr-only" id="user-wish-support-sr">Indtast din navn og email for at støtte dette brugerønske</div>
    		<div v-show="!hideInput">
    			<p><strong>{{ placeName }}</strong></p>
          <span class="close-btn" role="button" aria-label="Luk" @click="$emit('close');" tabindex="0">
            <span class="material-icons grey-text" aria-hidden="true">close</span>
          </span>

    			<div class="form-group">
    				<label class="control-label" for="user-name">Dit navn</label>
    				<input class="form-control" id="user-name" placeholder="Navn" aria-label="Dit navn" v-model="userName" :class="{'is-invalid' : nameError}">
    				<em class="font-italic">Navnet bliver synligt på Odense Rundt. Det behøver ikke være dit fulde navn. Du kan eksempelvis skrive P Hansen, hvis du hedder Peter Hansen.</em>
    			</div>

    			<div class="form-group">
    				<label class="control-label" for="user-email">Din e-mail</label>
    				<input class="form-control" id="user-email" placeholder="E-mail" aria-label="Din email" v-model="userEmail" :class="{'is-invalid' : emailError}">
    				<em class="font-italic">E-mail-adressen bliver ikke synlig på Odense Rundt. Vi sender dig en e-mail, hvor du kan bekræfte, at det er dig, der bakker op om brugerønsket.</em>
    			</div>

    			<button class="btn blue" @click="validateSupportData">Send</button>
    		</div>

    		<div v-show="supportConfirmed">
    			<p>Vi har nu sendt en besked til oplyste mail, hvor du skal bekræfte at du vil bakke op om brugerønsket</p>
    			<button class="btn blue" @click="$emit('close');">Ok</button>
    		</div>

    		<div v-show="alreadySupported">
    			<p>Du har allerede bakket op om dette brugerønske.</p>
    			<button class="btn blue" @click="$emit('close');">Ok</button>
    		</div>

    	</div>

    </div>
  </transition>
</template>

<script>
import BannedEmails from '@/assets/utilities/BannedEmails.js'
import axios from 'axios'

export default {
  data() {
    return {
      userName: '',
      userEmail: '',
      supportConfirmed: false,
      alreadySupported: false,
      hideInput: false,
      emailError: false,
      nameError: false,
    }
  },
  props: {
    placeName: {
      required: true,
    },
    placeId: {
      required: true,
    }
  },
  created() {
    this.$HelperFunctions.setScreenReaderFocus('user-wish-support-sr');
  },
  methods: {
    validateSupportData(e) {
  		e.stopPropagation();
  	  this.validateSupportUserName();
  		this.validateSupportEmail();

  	  if(!this.nameError && !this.emailError) {
  	    this.sendSupportConfirmEmail();
  	  }
  	},

  	validateSupportUserName() {
  		this.nameError = (this.userName == '' || this.userName == null || this.userName == undefined) ? true : false;
  	},

  	validateSupportEmail() {
  	  var atpos = this.userEmail.indexOf("@");
  	  var dotpos = this.userEmail.lastIndexOf(".");
  	  var domain = this.userEmail.split('@');

  	  if (atpos<1 || dotpos<atpos+2 || dotpos+2>=this.userEmail.length) {
  		  this.emailError = true;
  	  }
  	  else {
  	    var banned = false;
  	    for(var i = 0; i < BannedEmails.length; i++) {
  	      if(domain[1] == BannedEmails[i]) {
  	        banned = true;
  	        break;
  	      }
  	      else {
  	        continue;
  	      }
  	    }
        this.emailError = (banned) ? true : false;
  	  }
  	},

  	sendSupportConfirmEmail() {
      console.log('Gokendt');
      const params = new URLSearchParams();
      params.append('action', 'userWishLike');
      params.append('itemId', this.placeId);
      params.append('email', this.userEmail);
      params.append('name', this.userName);

      axios({
        method: 'post',
        url: 'https://apps.odenserundt.dk/apptools/orApi/',
        data: params
      }).then((response) => {
        console.log(response.data);
        this.hideInput = true;
				if(response.data == 'email.sent') {
					this.supportConfirmed = true;
				}
				else if(response.data == false) {
					this.alreadySupported = true;
				}
      });
  	},
  }
}
</script>

<style lang="css" scoped>
  #user-wish-support-box {
  	position: absolute;
  	z-index: 100101;
  	height: auto;
  	width: 300px;
  	padding: 10px;
  }

  .close-btn {
  	position: absolute;
    height: 30px;
    top: 4px;
    right: 5px;
    cursor: pointer;
  }

  #user-wish-support-box button {
  	position: relative;
  	width: 200px;
  	left: 50%;
  	margin-left: -100px;
  }

  em {
    font-size: 0.9em;
  }

</style>
